export default __webpack_public_path__ + "static/media/altbank.af362aaa.png";